import axios from 'axios';
import { Message } from 'element-ui';
import store from '@/store';
import router from '@/router';
class Request {
  instance;
  constructor(config) {
    this.instance = axios.create(config);
    // 请求拦截器
    this.instance.interceptors.request.use(
      (config) => {
        config.headers.Authorization = decodeURIComponent('Bearer ' + localStorage.getItem('token'));
        return config;
      },
      (err) => {
        return err;
      },
    );
    // 响应拦截器
    this.instance.interceptors.response.use(
      (res) => {
        if (res.data.code !== 200) {
          Message.error(res.data.msg);
        }
        if ([401].includes(res.data.code)) {
          localStorage.clear();
          router.push('/');
          store.dispatch('user/changeDialog', { isshow: true, type: 1 });
          store.dispatch('user/changeToken', '');
          return { code: '' };
        }
        return res.data;
      },
      (err) => {
        if (err.response.status) {
          // Toast.clear()
          // Notify({type: 'danger', message: '服务器开小差了'})
        }
        return err;
      },
    );
  }
}

export default Request;
